import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout/MainLayout';
import Dashboard from './pages/Dashboard/Dashboard';
import RoleManagement from './pages/RoleManagement/RoleManagement';
import UserManagement from './pages/UserManagement/UserManagement';
import AuditTrail from './pages/AuditTrail/AuditTrail';
import StudyManagement from './pages/StudyManagement/StudyManagement';
import Login from './components/auth/LoginForm/LoginForm';
import MainFroms from './pages/StudyManagement/Consent';
import StudyReport from './pages/StudyReport/StudyReport';

//   FIXED: Proper role checking based on backend response structure
const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  console.log('🔐 ProtectedRoute Check:', {
    hasToken: !!token,
    userRole: user.role?.roleName,
    allowedRoles: allowedRoles,
  });

  if (!token) {
    console.log('  No token - redirecting to login');
    return <Navigate to='/login' replace />;
  }

  const userRoleName = user.role?.roleName;

  if (allowedRoles && !allowedRoles.includes(userRoleName)) {
    console.log('  Role not allowed:', {
      userRole: userRoleName,
      allowedRoles: allowedRoles,
    });

    if (
      userRoleName === 'Principal Investigator' ||
      userRoleName === 'Co-ordinator member'
    ) {
      return <Navigate to='/study-management' replace />;
    }
    return <Navigate to='/' replace />;
  }

  console.log('  Access granted');
  return children;
};

// Public Route Component
const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  if (token) {
    const userRoleName = user.role?.roleName;

    console.log(
      '🔄 Already logged in, redirecting based on role:',
      userRoleName
    );

    if (
      userRoleName === 'Principal Investigator' ||
      userRoleName === 'Co-ordinator member'
    ) {
      return <Navigate to='/study-management' replace />;
    }
    return <Navigate to='/' replace />;
  }

  return children;
};

const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <MainLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: '',
        element: (
          <ProtectedRoute allowedRoles={['CRO Admin', 'Sponsor']}>
            <Dashboard />
          </ProtectedRoute>
        ),
      },
      {
        path: 'role-management',
        element: (
          <ProtectedRoute allowedRoles={['CRO Admin']}>
            <RoleManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: 'user-management',
        element: (
          <ProtectedRoute allowedRoles={['CRO Admin']}>
            <UserManagement />
          </ProtectedRoute>
        ),
      },
      {
        path: 'audit-trail',
        element: (
          <ProtectedRoute allowedRoles={['CRO Admin']}>
            <AuditTrail />
          </ProtectedRoute>
        ),
      },
      {
        path: 'study-report',
        element: (
          <ProtectedRoute allowedRoles={['CRO Admin', 'Sponsor']}>
            <StudyReport />
          </ProtectedRoute>
        ),
      },
      {
        path: 'study-management',
        element: (
          <ProtectedRoute allowedRoles={['Principal Investigator']}>
            <StudyManagement />
          </ProtectedRoute>
        ),
      },

      {
        path: 'survey/:studyId',
        element: (
          <ProtectedRoute allowedRoles={['Principal Investigator']}>
            <MainFroms />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to='/' replace />,
  },
]);

export { router };
